import * as Yup from "yup";

export const validationSchema = Yup.object({
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().nullable(),
  email: Yup.string().email("Invalid email").required("Email is required"),
  dob: Yup.date().nullable(),
  nationality: Yup.array().of(Yup.string()).nullable(),
  mobileCountryCode: Yup.string().required("Country code is required"),
  mobile: Yup.string().required("Mobile number is required"),
  gender: Yup.string().nullable(),
  image: Yup.string().nullable(),
  emailVerification: Yup.boolean(),
  mobileVerification: Yup.boolean(),
  passwordResetRequired: Yup.boolean(),
  theme: Yup.string().nullable(),
  language: Yup.string().nullable(),
  password: Yup.string().when("passwordOption", {
    is: "setOwn",
    then: (schema) => schema.required("Password is required"),
    otherwise: (schema) => schema.nullable(),
  }),
  passwordOption: Yup.string().required("Password option is required"),
});